exports = module.exports = require("../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1X_-w2Mncy-yqGjNmB_1s9>div{overflow:visible}", ""]);
// Exports
exports.locals = {
	"viewStyle": "_1X_-w2Mncy-yqGjNmB_1s9"
};